import { makeAutoObservable } from "mobx";

export default class ProfileStore {
    constructor() {
        this._userInfo = {};
        this._users = {};

        makeAutoObservable(this);
    }

    setUserInfo(userInfo) {
        this._userInfo = userInfo || {};
    }

    setUsers(users) {
        this._users = users || {};
    }

    reset() {
        this.setUserInfo({});
        this.setUsers({});
    }

    get userInfo() {
        return this._userInfo;
    }

    get users() {
        return this._users;
    }
}
